export default "<p>route-trip-mangement works!</p>\r\n";